module.exports = __webpack_public_path__ + "src/client/components/LandingPage/img/icon-doc.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/LandingPage/img/icon-doc.png
// module id = 1212
// module chunks = 0